import {isReadOnlyDimension} from '@packages/systems/designer/is-read-only-dimension';
import {abilityFeature} from '../abilityFeature';

export const isReadOnly = abilityFeature({
  key: 'isReadOnly',
  isValid: function isReadOnlyValid(state, config) {
    return isReadOnlyDimension.isValid(state, {isReadOnly: config});
  },
});
